import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Typography, Paper } from "@mui/material";

export default function Account() {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const user = accounts[0];

  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user, navigate]);

  if (!user) return null;

  return (
    <>
      <Typography variant="h2">Moje konto</Typography>
      <Paper sx={{ mt: 4, p: 4 }}>
        <Typography variant="h4" gutterBottom>
          {user.name}
        </Typography>

        <Typography variant="body1">
          <strong>Adres e-mail:</strong> {user.username}
        </Typography>

        <Typography variant="body1">
          <strong>Identyfikator obiektu:</strong> {user.localAccountId}
        </Typography>
      </Paper>
    </>
  );
}
